import React from 'react'
import PropTypes from 'prop-types'

import { StyledCarrouselSlide, StyledIconButton } from './CarrouselSlide.styled'

import ExpandIcon from '../../../images/icons/expand.svg'
import NormalizeMedia from '../../../utils/NormalizeMedia'

const CarrouselSlide = ({
  className,
  hasExpandButton,
  setIsPopinOpen,
  ...media
}) => {
  return (
    <StyledCarrouselSlide className={className}>
      {NormalizeMedia(media)}
      {hasExpandButton && setIsPopinOpen && (
        <StyledIconButton onClick={() => setIsPopinOpen(true)}>
          <ExpandIcon />
        </StyledIconButton>
      )}
    </StyledCarrouselSlide>
  )
}

CarrouselSlide.propTypes = {
  className: PropTypes.any,
  hasExpandButton: PropTypes.bool,
  setIsPopinOpen: PropTypes.func,
}

export default CarrouselSlide
